import { HERO_CONTENT } from "../../data/siteData";
import "./Hero.css";

function Hero() {
  return (
    <section className="hero" style={{ backgroundImage: `url(${HERO_CONTENT.bgImage})` }}>
      <div className="hero__overlay" />
      <div className="hero__content">
        <h1 className="hero__title">{HERO_CONTENT.title}</h1>
        <p className="hero__tagline">{HERO_CONTENT.tagline}</p>
        <a href={HERO_CONTENT.ctaLink} className="hero__cta">
          {HERO_CONTENT.ctaLabel}
        </a>
      </div>
    </section>
  );
}

export default Hero;